import React, { useEffect } from 'react'
import Configs from './pages/Configs';
import Onboarding from './pages/Onboarding';
import TermsAndConditions from './pages/TermsAndConditions';
import MeetWithDietitian from './pages/MeetWithDietitian';
import { useSettingsHook } from '../../../Hooks/communicators/useSettingsHook';

export default function SettingsContent() {
    const {
        selectedSettingsPage,
    } = useSettingsHook();

    const returnSelectedPage = () => {
        switch (selectedSettingsPage) {
            case 1:
                return <Configs />
            case 2:
                return <Onboarding />
            case 3:
                return <TermsAndConditions />
            case 4:
                return <MeetWithDietitian />
            default:
                return <Configs />
        };
    };

    return (
        <div className='flex justify-center items-center'>
            {returnSelectedPage()}
        </div>
    )
}
